import { Catalog } from '@df/catalog/catalog.interfaces';
import { NICmsContentComponent } from '@icms/core/content';
export namespace NProductViewLayout {
    export const BLOCK_ID = 'product-page-layout';
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}
    export interface IBlockDataContent {
        /**
         * Social components list
         */
        socialComponents: NICmsContentComponent.IData[];
        /**
         * Editorial components list
         */
        editorialComponents: NICmsContentComponent.IData[];
        /**
         * Middle components list
         */
        middleComponents: NICmsContentComponent.IData[];
        /**
         * Reviews components list
         */
        // reviewsComponents: NICmsContentComponent.IData[];
        /**
         * Bottom components list
         */
        bottomComponents: NICmsContentComponent.IData[];
        /**
         * Bottom components list
         */
        rightComponents: NICmsContentComponent.IData[];
        /**
         * Delivery and returns copy
         */
        deliveryCopy?: string;
        /**
         * Free delivery label
         */
        deliveryNote?: string;
        /**
         * Hide qty for retail store
         */
        hideRetailQty?: boolean;
    }
    export enum ELayout {
        bundle,
        default
    }
}
